module.exports = __webpack_public_path__ + "img/uploadbkg.7f886e47.png";